import React from 'react';

import {theme} from '../constants';

type Props = {
  item: any;
  style?: React.CSSProperties;
};

export const ProductSale: React.FC<Props> = ({item, style}) => {
  if (item.oldPrice) {
    return (
      <div
        style={{
          backgroundColor: theme.colors.pastelMint,
          alignSelf: 'flex-start',
          paddingLeft: 6,
          paddingRight: 6,
          paddingTop: 1,
          paddingBottom: 1,
          borderRadius: 6,
          color: theme.colors.steelTeal,
          textTransform: 'uppercase',
          ...theme.fonts.DM_Sans_700Bold,
          fontSize: 8,
          lineHeight: 1.7,
          ...style,
        }}
      >
        sale
      </div>
    );
  }

  return null;
};
